document.documentElement.classList.remove('no-js');

const SV_I18N = (()=>{try{return JSON.parse(document.getElementById('SVTranslations')?.textContent||'{}')}catch(_){return {}}})();
const svT = (key,fallback='') => SV_I18N[key] || fallback;


const SV_MODEL_PRIORITY = (() => {
  const norm = value => (value || '').toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .replace(/ł/g,'l')
    .replace(/[._–—-]+/g,' ')
    .replace(/\s+/g,' ')
    .trim();

  const aliases = {
    'night vision': 'nv i',
    'night vision i': 'nv i',
    'night vision 1': 'nv i',
    'nv 1': 'nv i',
    'night vision ii': 'nv ii',
    'night vision 2': 'nv ii',
    'nv 2': 'nv ii',
    'selene': 'seline',
    'celine': 'seline'
  };

  const canonical = value => {
    const key = norm(value);
    return aliases[key] || key;
  };

  // User-approved catalogue graduation, 2026-09-17.
  // Only the tier is significant: I first, II second, III last.
  // Order inside a tier stays stable with the Shopify catalogue order.
  const tiers = {
    damskie: [
      ['aurea','bella','gia','luna','muse','pebble','pixel','shade','sienna','vault','vela','vivien'],
      ['ivy','mist','sirene','nexa','orbit','ridge','seline','titan'],
      ['aero','aura','axis','nv ii','nova','slab','swift','volt']
    ],
    meskie: [
      ['aura','shade','ivy','titan','mist','monroe','nv i','nova','pixel','ridge'],
      ['aero','iced alloy','nexa','noir','orbit','vault','volt'],
      ['opium','runner','slab','swift']
    ]
  };

  const tier = (context, value) => {
    const ctx = norm(context);
    const groups = tiers[ctx];
    if (!groups) return 9;
    const key = canonical(value);
    for (let i=0;i<groups.length;i++) {
      if (groups[i].includes(key)) return i + 1;
    }
    return 9;
  };

  return { tier, canonical };
})();


(() => {
  const menu=document.querySelector('[data-mobile-menu]');
  const openBtn=document.querySelector('[data-mobile-menu-open]');
  const closeBtn=document.querySelector('[data-mobile-menu-close]');
  const backdrop=document.querySelector('[data-mobile-menu-backdrop]');
  if(!menu || !openBtn)return;

  const setOpen=open=>{
    menu.classList.toggle('open',open);
    backdrop?.classList.toggle('open',open);
    if(backdrop)backdrop.hidden=false;
    menu.setAttribute('aria-hidden',open?'false':'true');
    openBtn.setAttribute('aria-expanded',open?'true':'false');
    document.body.classList.toggle('sv-menu-open',open);
    if(!open){
      window.setTimeout(()=>{if(backdrop && !backdrop.classList.contains('open'))backdrop.hidden=true},220);
    }
  };

  openBtn.addEventListener('click',()=>setOpen(true));
  closeBtn?.addEventListener('click',()=>setOpen(false));
  backdrop?.addEventListener('click',()=>setOpen(false));
  menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setOpen(false)));
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape' && menu.classList.contains('open')){
      setOpen(false);
      openBtn.focus();
    }
  });

  // Never leave the drawer/body lock active after rotating/resizing to desktop.
  window.addEventListener('resize',()=>{
    if(window.innerWidth>1000 && menu.classList.contains('open'))setOpen(false);
  });
})();

(() => {
  const norm = value => (value || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ł/g,'l');

  // Whole-card navigation.
  document.querySelectorAll('[data-card-url]').forEach(card => {
    card.tabIndex = card.tabIndex >= 0 ? card.tabIndex : 0;
    const go = e => {
      if (e.target.closest('a,button,input,select,textarea')) return;
      if (card.dataset.cardUrl) location.href = card.dataset.cardUrl;
    };
    card.addEventListener('click', go);
    card.addEventListener('keydown', e => {
      if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('a,button,input,select,textarea')) {
        e.preventDefault(); if (card.dataset.cardUrl) location.href = card.dataset.cardUrl;
      }
    });
  });

  // Virtual category pages on /collections/all?sv=...
  const grid = document.querySelector('#productGrid');
  if (grid) {
    const params = new URLSearchParams(location.search);
    const category = norm(params.get('sv'));
    const style = norm(params.get('svstyle'));
    const cards = [...grid.querySelectorAll('.product-card')];
    const title = document.querySelector('[data-virtual-title]');
    const desc = document.querySelector('[data-virtual-description]');
    const count = document.querySelector('[data-visible-count]');
    const empty = document.querySelector('[data-virtual-empty]');

    const copy = {
      damskie:['Damskie.','Modele o różnym charakterze — od lekkich opraw po mocniejsze formy. Kolory wybierzesz na karcie modelu.'],
      meskie:['Męskie.','Codzienne, klasyczne i wyraziste produkty South Vision. Kolory wybierzesz bezpośrednio na karcie modelu.'],
      dzieciece:['Dziecięce.','Lekkie modele dziecięce. Modele sportowe dziecięce znajdziesz wyłącznie w dziale Sport.'],
      everyday:['Na co dzień.','Okulary do codziennego stylu — osobne produkty dla każdej oferty i wersji kolorystycznej.'],
      akcesoria:['Akcesoria.','Etui, woreczki, ściereczki i dodatki do ochrony oraz przechowywania okularów.'],
      sport:['Sport.','Modele stworzone z myślą o ruchu, większej osłonie i zastosowaniach performance.']
    };
    if (category && copy[category]) {
      if (title) title.textContent = copy[category][0];
      if (desc) desc.textContent = copy[category][1];
    }

    let visible = 0;
    cards.forEach(card => {
      const groups = norm(card.dataset.svGroups);
      const cardStyle = norm(card.dataset.svStyle);
      let show = true;
      if (category) show = groups.split(/\s+/).includes(category);
      if (show && style) show = cardStyle.includes(style);
      card.dataset.svFilterMatch = show ? '1' : '0';
      card.hidden = !show;
      if (show) visible++;
    });
    if (count) count.textContent = visible || cards.length;
    if (empty) empty.hidden = visible !== 0 || (!category && !style);

    // Preserve virtual parameters through native sort/filter forms.
    document.querySelectorAll('[data-preserve-sv]').forEach(i => i.value = params.get('sv') || '');
    document.querySelectorAll('[data-preserve-style]').forEach(i => i.value = params.get('svstyle') || '');
    document.querySelectorAll('.pagination a,.sv-pagination a').forEach(a => {
      const u = new URL(a.href, location.origin);
      if (params.get('sv')) u.searchParams.set('sv',params.get('sv'));
      if (params.get('svstyle')) u.searchParams.set('svstyle',params.get('svstyle'));
      a.href = u.toString();
    });
  }

  // Eyewear category rule: ONE MODEL = ONE CARD. Colours stay inside the card as swatches.
  // The Liquid template loads up to 250 colour-products, then this module groups them into models
  // and paginates 25 MODELS per page. Accessories are intentionally excluded.
  const modelGrid = document.querySelector('#productGrid[data-sv-model-grid]');
  if (modelGrid) {
    const modelCards = [...modelGrid.querySelectorAll('.product-card')];
    const pager = document.querySelector('[data-sv-model-pagination]');
    const count = document.querySelector('[data-visible-count]');
    const perPage = Math.max(1, Number(modelGrid.dataset.modelsPerPage || 25));
    let page = 1;

    const paramsForRank = new URLSearchParams(location.search);
    const rankingContextRaw = (modelGrid.dataset.svRankingContext || paramsForRank.get('sv') || '').toLowerCase();
    const rankingContext = rankingContextRaw.includes('damsk') ? 'damskie' : (rankingContextRaw.includes('mesk') || rankingContextRaw.includes('męsk') ? 'meskie' : '');
    const explicitSort = (paramsForRank.get('sort_by') || '').toLowerCase();
    const usePriorityOrder = !!rankingContext && (!explicitSort || explicitSort === 'manual');
    modelCards.forEach((card,index)=>{ card.dataset.svOriginalOrder = String(index); });
    modelCards.sort((a,b)=>{
      if (!usePriorityOrder) return Number(a.dataset.svOriginalOrder)-Number(b.dataset.svOriginalOrder);
      const aModel = a.dataset.svModel || a.dataset.svFamily || a.dataset.svTitle || '';
      const bModel = b.dataset.svModel || b.dataset.svFamily || b.dataset.svTitle || '';
      const tierDiff = SV_MODEL_PRIORITY.tier(rankingContext,aModel) - SV_MODEL_PRIORITY.tier(rankingContext,bModel);
      return tierDiff || Number(a.dataset.svOriginalOrder)-Number(b.dataset.svOriginalOrder);
    });
    modelCards.forEach(card=>modelGrid.appendChild(card));

    const cardKey = card => (card.dataset.svModelKey || card.dataset.svFamily || card.dataset.svModel || card.dataset.svTitle || '').trim().toLowerCase();
    const representatives = () => {
      const seen = new Set();
      const reps = [];
      modelCards.forEach(card => {
        const eligible = card.dataset.svFilterMatch !== '0';
        if (!eligible) { card.dataset.svModelDuplicate='0'; return; }
        const key = cardKey(card);
        if (key && seen.has(key)) { card.dataset.svModelDuplicate='1'; return; }
        if (key) seen.add(key);
        card.dataset.svModelDuplicate='0';
        reps.push(card);
      });
      return reps;
    };

    const renderPager = (pages) => {
      if (!pager) return;
      if (pages <= 1) { pager.innerHTML=''; pager.hidden=true; return; }
      pager.hidden=false;
      let html = page > 1 ? `<button type="button" data-model-page="${page-1}" aria-label="${svT('previousPage','Poprzednia strona')}">←</button>` : '';
      for (let i=1;i<=pages;i++) {
        if (pages > 7 && i !== 1 && i !== pages && Math.abs(i-page)>2) {
          if ((i===2 && page>4) || (i===pages-1 && page<pages-3)) html += '<span>…</span>';
          continue;
        }
        html += `<button type="button" data-model-page="${i}"${i===page?' class="is-current" aria-current="page"':''}>${i}</button>`;
      }
      if (page < pages) html += `<button type="button" data-model-page="${page+1}" aria-label="${svT('nextPage','Następna strona')}">→</button>`;
      pager.innerHTML=html;
      pager.querySelectorAll('[data-model-page]').forEach(btn=>btn.addEventListener('click',()=>{
        page=Number(btn.dataset.modelPage)||1;
        renderModels();
        modelGrid.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      }));
    };

    const renderModels = () => {
      const reps=representatives();
      const pages=Math.max(1,Math.ceil(reps.length/perPage));
      if(page>pages) page=pages;
      const pageSet=new Set(reps.slice((page-1)*perPage,page*perPage));
      modelCards.forEach(card=>{
        const isRep=card.dataset.svModelDuplicate!=='1' && card.dataset.svFilterMatch!=='0';
        card.hidden=!isRep || !pageSet.has(card);
      });
      if(count) count.textContent=reps.length;
      renderPager(reps.length?pages:0);
      modelGrid.classList.add('product-grid-ready','product-grid-model-deduped');
    };

    renderModels();
  }

  // Native collection filter panel.
  const panel = document.querySelector('[data-shopify-filter-panel]');
  document.querySelectorAll('[data-filter-toggle]').forEach(btn => btn.addEventListener('click', () => {
    if (!panel) return;
    panel.hidden = !panel.hidden;
    const target = panel.querySelector(`[data-filter-name="${CSS.escape(btn.dataset.filterToggle)}"]`);
    if (target) target.open = true;
  }));

  // Find Your Frame — shared tool for collection and routed catalogue.
  const fitModal = document.querySelector('[data-fit-modal]');
  if (fitModal) {
    const catalogGrid = document.querySelector('#routeProductGrid') || document.querySelector('#productGrid') || (document.body.classList.contains('template-sport') ? document.querySelector('#MainContent') : null);
    const state = {style:'',fit:'',priority:''};
    const result = fitModal.querySelector('[data-fit-result]');
    const normFit = value => norm(value).replace(/\s+/g,' ');

    const allCards = () => {
      if (!catalogGrid) return [];
      return [...catalogGrid.querySelectorAll('.product-card,.sport-product-tile')].filter(card => card.dataset.svFilterMatch !== '0' && card.dataset.svModelDuplicate !== '1');
    };

    const openFit = () => {
      fitModal.hidden = false;
      document.body.classList.add('fit-modal-open');
      fitModal.querySelector('.fit-modal__close')?.focus();
    };
    const closeFit = () => {
      fitModal.hidden = true;
      document.body.classList.remove('fit-modal-open');
    };

    const updateProgress = () => {
      const completed = [state.style,state.fit,state.priority].filter(Boolean).length;
      fitModal.querySelectorAll('[data-fit-progress]').forEach((bar,i) => {
        bar.classList.toggle('active', i < Math.max(1,completed));
      });
      return completed;
    };

    const scoreCard = card => {
      const style = normFit(card.dataset.svStyle);
      const fit = normFit(card.dataset.svFit);
      const groups = normFit(card.dataset.svGroups);
      const pol = normFit(card.dataset.svPolarized);
      let score = 0;
      const reasons = [];

      if (state.style && state.style !== 'any') {
        if (state.style === 'sport') {
          if (groups.includes('sport')) { score += 6; reasons.push('Sport'); }
        } else if (style.includes(state.style)) {
          score += 6; reasons.push(state.style);
        }
      } else if (state.style === 'any') score += 1;

      if (state.fit && state.fit !== 'any') {
        if (fit.includes(state.fit)) { score += 5; reasons.push(`Fit ${state.fit}`); }
      } else if (state.fit === 'any') score += fit ? 1 : 0;

      if (state.priority === 'polarized') {
        const yes = pol === 'true' || pol === '1' || pol.includes('tak') || pol.includes('polar');
        if (yes) { score += 5; reasons.push('Polaryzacja'); }
      } else if (state.priority === 'style') {
        if (style) { score += 2; reasons.push('Styl'); }
      } else if (state.priority === 'comfort') {
        if (fit) { score += 2; reasons.push('Dopasowanie'); }
      } else if (state.priority === 'any') score += 1;

      return {card,score,reasons};
    };

    const renderFit = () => {
      if (!result) return;
      const completed = updateProgress();

      if (completed < 3) {
        const next = completed + 1;
        const labels = {
          1:['Zacznij od charakteru oprawy.','Wybierz styl, który najbardziej Cię interesuje.'],
          2:['Teraz dopasowanie.','Jeśli nie znasz swojego rozmiaru, wybierz „Nie wiem”.'],
          3:['Na koniec priorytet.','Powiedz nam, co jest dla Ciebie najważniejsze.']
        };
        result.innerHTML = `<div class="fit-result-empty"><span>0${next} / 03</span><strong>${labels[next][0]}</strong><p>${labels[next][1]}</p></div>`;
        return;
      }

      const cards = allCards();
      if (!cards.length) {
        result.innerHTML = '<div class="fit-no-data"><strong>Na razie nie mamy propozycji w tej kategorii.</strong><p>Zobacz pełną kolekcję lub zmień jeden z wyborów.</p></div>';
        return;
      }

      let scored = cards.map(scoreCard).sort((a,b) => b.score-a.score);
      const positive = scored.filter(x => x.score > 0);
      if (positive.length) scored = positive;
      const seen = new Set();
      scored = scored.filter(({card}) => {
        const key = (card.dataset.svFamily || card.dataset.svTitle || card.dataset.sportModel || '').toLowerCase();
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      }).slice(0,3);

      if (!scored.length) {
        result.innerHTML = '<div class="fit-no-data"><strong>Nie znaleźliśmy wyraźnego dopasowania.</strong><p>Spróbuj zmienić jeden z wyborów albo przejdź do pełnej kolekcji.</p></div>';
        return;
      }

      result.innerHTML =
        '<div class="fit-result-heading"><div><span>PROPOZYCJE DLA CIEBIE</span><br><strong>Sprawdź te modele.</strong></div><span>TOP 3</span></div>' +
        '<div class="fit-result-grid">' +
        scored.map(({card,reasons}) => {
          const link = card.dataset.cardUrl || '#';
          const name = card.dataset.svTitle || card.querySelector('.product-top strong')?.textContent.trim() || 'Model';
          const price = card.dataset.svPrice || '';
          const img = card.dataset.svImage || card.querySelector('.product-media img')?.src || '';
          const why = reasons.slice(0,2).join(' · ') || 'South Vision';
          const safeName = name.replace(/"/g,'&quot;');
          return `<a class="fit-result-card" href="${link}">
            ${img ? `<img src="${img}" alt="${safeName}">` : ''}
            <div><strong>${name}</strong><span>${price}</span><em>${why} →</em></div>
          </a>`;
        }).join('') +
        '</div>';
    };

    document.querySelectorAll('[data-fit-open]').forEach(btn => btn.addEventListener('click', openFit));
    fitModal.querySelectorAll('[data-fit-close]').forEach(x => x.addEventListener('click', closeFit));
    fitModal.querySelector('[data-fit-reset]')?.addEventListener('click', () => {
      state.style=''; state.fit=''; state.priority='';
      fitModal.querySelectorAll('[data-fit-group] button').forEach(x => x.classList.remove('active'));
      renderFit();
    });

    fitModal.querySelectorAll('[data-fit-group]').forEach(group => {
      group.querySelectorAll('button').forEach(btn => btn.addEventListener('click', () => {
        group.querySelectorAll('button').forEach(x => x.classList.remove('active'));
        btn.classList.add('active');
        state[group.dataset.fitGroup] = normFit(btn.dataset.value);
        renderFit();
      }));
    });

    fitModal.addEventListener('keydown', e => { if (e.key === 'Escape') closeFit(); });
    if (location.hash === '#find-your-frame') setTimeout(openFit,150);
    renderFit();
  }



  // CART — reliable quantity controls using native Shopify cart form.
  const cartForm=document.querySelector('[data-cart-form]');
  if(cartForm){
    const updateButton=cartForm.querySelector('[data-cart-update]');
    let updateTimer=null;

    const submitUpdate=()=>{
      if(!updateButton)return;
      window.clearTimeout(updateTimer);
      updateTimer=window.setTimeout(()=>{
        if(cartForm.requestSubmit)cartForm.requestSubmit(updateButton);
        else updateButton.click();
      },300);
    };

    cartForm.querySelectorAll('[data-cart-line]').forEach(line=>{
      const input=line.querySelector('[data-cart-qty-input]');
      const minus=line.querySelector('[data-cart-qty-minus]');
      const plus=line.querySelector('[data-cart-qty-plus]');
      if(!input)return;

      const setValue=value=>{
        const next=Math.max(0,Number(value)||0);
        input.value=next;
        submitUpdate();
      };

      minus?.addEventListener('click',()=>setValue(Number(input.value)-1));
      plus?.addEventListener('click',()=>setValue(Number(input.value)+1));
      input.addEventListener('change',()=>setValue(input.value));
    });
  }

  // PDP interactions
  const root = document.querySelector('[data-product-root]');
  if (root) {
    const carousel=root.querySelector('#carousel');
    const slides=[...root.querySelectorAll('.slide')];
    const thumbs=[...root.querySelectorAll('.thumb')];
    const thumbRow=root.querySelector('#thumbRow');
    const originalThumbOrder=[...thumbs];
    const slideNo=root.querySelector('#slideNo');
    const slideCount=root.querySelector('#slideCount');
    const fitPair=root.querySelector('[data-fit-pair]');
    const legacyFitHtml=fitPair?.innerHTML || '';
    const fitLimit=Math.max(1,Number(root.dataset.fitLimit||1));
    let index=0;
    let filenameGalleryActive=false;

    const polishAscii=value=>String(value||'')
      .replace(/[łŁ]/g,'l')
      .replace(/[ß]/g,'ss');

    const normalizeMediaKey=value=>{
      let text='';
      try{text=decodeURIComponent(String(value||''))}catch(e){text=String(value||'')}
      text=text.split('?')[0].split('#')[0].replace(/\.[a-z0-9]{2,6}$/i,'');
      return polishAscii(text)
        .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
        .toLowerCase()
        // Kolory wieloczłonowe mogą być zapisywane w nazwie pliku z underscore,
        // np. IVY-PINK_GRADIENT-1.jpg. Wewnątrz klucza traktujemy _ jak separator słów.
        .replace(/_/g,'-')
        .replace(/[^a-z0-9]+/g,'-')
        .replace(/^-+|-+$/g,'')
        .replace(/-{2,}/g,'-');
    };

    const modelKey=normalizeMediaKey(root.dataset.productModel || root.dataset.productTitle || '');
    const colorOptionPosition=Number(root.dataset.colorOptionPosition||0);
    const singleProduct=root.dataset.singleProduct==='1';
    const svGenderParam=(new URLSearchParams(location.search).get('sv_gender')||'').toLowerCase();
    const galleryGenderContext=(svGenderParam==='d'||svGenderParam==='m')?svGenderParam:'';
    const mediaAllowedByContext=info=>{
      if(!galleryGenderContext || !info)return true;
      if(info.kind==='product')return true;
      if(info.kind==='female')return galleryGenderContext==='d';
      if(info.kind==='male')return galleryGenderContext==='m';
      return true;
    };

    const variantColorKeys=variant=>{
      const candidates=[];
      if(colorOptionPosition>=1 && colorOptionPosition<=3){
        candidates.push(variant?.[`option${colorOptionPosition}`]);
      }
      if(variant?.title && variant.title!=='Default Title')candidates.push(variant.title);
      const joined=[variant?.option1,variant?.option2,variant?.option3]
        .filter(Boolean)
        .filter(v=>v!=='Default Title')
        .join('-');
      if(joined)candidates.push(joined);
      return [...new Set(candidates.map(normalizeMediaKey).filter(Boolean))];
    };

    const parseNamedSuffix=suffix=>{
      const productShot=suffix.match(/^([1-4])$/);
      if(productShot){
        const n=Number(productShot[1]);
        const labels={1:'HERO',2:'FRONT HERO',3:'PROFILE / SIDE',4:'BACK HERO'};
        return {kind:'product',number:n,rank:n,label:labels[n]};
      }
      const male=suffix.match(/^(?:model-)?m-(\d+)$/);
      if(male){
        const n=Number(male[1]);
        return {kind:'male',number:n,rank:100+n,label:`MODEL / MEN ${String(n).padStart(2,'0')}`};
      }
      const female=suffix.match(/^(?:model-)?d-(\d+)$/);
      if(female){
        const n=Number(female[1]);
        return {kind:'female',number:n,rank:200+n,label:`MODEL / WOMEN ${String(n).padStart(2,'0')}`};
      }
      return null;
    };

    const namedInfoForNode=(node,variant)=>{
      if(!node || !variant || !modelKey)return null;
      const keys=[node.dataset.fileKey,node.dataset.mediaAlt]
        .map(normalizeMediaKey)
        .filter(Boolean);
      const colorKeys=variantColorKeys(variant);
      for(const key of keys){
        for(const colorKey of colorKeys){
          const prefix=`${modelKey}-${colorKey}-`;
          if(!key.startsWith(prefix))continue;
          const parsed=parseNamedSuffix(key.slice(prefix.length));
          if(parsed)return {...parsed,key,colorKey};
        }
      }
      return null;
    };

    // ONE OFFER = ONE PRODUCT: for a product with only the Default variant,
    // the entire media set already belongs to this exact offer. We only need
    // the suffix (1/2/3/4/MODEL-M-n/MODEL-D-n; legacy M-n/D-n also supported), so colours such as PINK_GRADIENT work
    // without any variant-family matching.
    const singleProductNamedInfo=node=>{
      if(!node)return null;
      const keys=[node.dataset.fileKey,node.dataset.mediaAlt]
        .map(normalizeMediaKey)
        .filter(Boolean);
      for(const key of keys){
        const match=key.match(/(?:^|-)([1-4]|(?:model-)?m-\d+|(?:model-)?d-\d+)$/);
        if(!match)continue;
        const parsed=parseNamedSuffix(match[1]);
        if(parsed)return {...parsed,key,colorKey:''};
      }
      return null;
    };

    const visibleIndexes=()=>slides
      .map((slide,n)=>({slide,n,rank:Number(slide.dataset.mediaRank||10000)}))
      .filter(x=>!x.slide.hidden)
      .sort((a,b)=>a.rank-b.rank || a.n-b.n)
      .map(x=>x.n);

    const updateCount=()=>{
      const visible=visibleIndexes();
      if(slideCount)slideCount.textContent=visible.length;
      if(slideNo)slideNo.textContent=Math.max(1,visible.indexOf(index)+1);
    };

    const show=i=>{
      if(!slides.length)return;
      const visible=visibleIndexes();
      if(!visible.length)return;

      let requested=Number(i);
      if(!visible.includes(requested))requested=visible[0];
      index=requested;

      slides.forEach((slide,n)=>slide.classList.toggle('active',n===index && !slide.hidden));
      thumbs.forEach(thumb=>{
        const active=String(thumb.dataset.mediaId)===String(slides[index]?.dataset.mediaId) && !thumb.hidden;
        thumb.classList.toggle('active',active);
        thumb.setAttribute('aria-current',active?'true':'false');
      });

      const visiblePosition=visible.indexOf(index)+1;
      if(slideNo)slideNo.textContent=visiblePosition;
      if(slideCount)slideCount.textContent=visible.length;
      const activeThumb=thumbs.find(t=>String(t.dataset.mediaId)===String(slides[index]?.dataset.mediaId));
      activeThumb?.scrollIntoView({block:'nearest',inline:'nearest'});
    };

    const stepSlide=direction=>{
      const visible=visibleIndexes();
      if(!visible.length)return;
      let currentPos=visible.indexOf(index);
      if(currentPos<0)currentPos=0;
      const nextPos=(currentPos+direction+visible.length)%visible.length;
      show(visible[nextPos]);
    };

    const showMediaId=id=>{
      if(!id)return;
      const target=slides.findIndex(s=>String(s.dataset.mediaId)===String(id) && !s.hidden);
      if(target>=0)show(target);
    };

    const mediaBelongsToVariant=(node,variantId)=>{
      const ids=(node?.dataset?.variantIds||'').split('|').filter(Boolean);
      // No Shopify assignment = common image, visible for every variant in legacy mode.
      return ids.length===0 || ids.includes(String(variantId));
    };

    const restoreLegacyFit=()=>{
      if(fitPair)fitPair.innerHTML=legacyFitHtml;
    };

    const renderNamedFit=namedEntries=>{
      if(!fitPair)return;
      const modelEntries=namedEntries
        .filter(entry=>entry.info.kind==='male' || entry.info.kind==='female')
        .sort((a,b)=>a.info.rank-b.info.rank);

      if(!modelEntries.length){
        if(fitPair)fitPair.innerHTML='';
        return;
      }

      const chosen=[];
      const firstMale=modelEntries.find(x=>x.info.kind==='male');
      const firstFemale=modelEntries.find(x=>x.info.kind==='female');
      if(fitLimit>=2 && firstMale && firstFemale){
        chosen.push(firstMale,firstFemale);
      }else{
        chosen.push(...modelEntries.slice(0,fitLimit));
      }

      fitPair.innerHTML='';
      chosen.slice(0,fitLimit).forEach(entry=>{
        const source=entry.slide.querySelector('img');
        if(!source)return;
        const wrap=document.createElement('div');
        wrap.className='fit-static has-image';
        const img=document.createElement('img');
        img.className='real-img';
        img.loading='lazy';
        img.src=source.currentSrc || source.src;
        img.alt=source.alt || root.dataset.productTitle || '';
        wrap.append(img);
        fitPair.appendChild(wrap);
      });
    };

    const resetMediaMetadata=()=>{
      slides.forEach((slide,n)=>{
        slide.dataset.mediaRank=String(10000+n);
        const label=slide.querySelector('[data-media-label]');
        if(label)label.textContent=(slide.dataset.mediaAlt||'PRODUCT / IMAGE').replace('[FIT]','').replace('[EDITORIAL]','').trim() || 'PRODUCT / IMAGE';
      });
      originalThumbOrder.forEach(thumb=>thumbRow?.appendChild(thumb));
    };

    const filterGalleryForVariant=variant=>{
      if(!variant || !slides.length)return false;
      resetMediaMetadata();

      // New architecture: a Shopify product is one exact sellable offer.
      // Do not filter its images by colour variants; just order/label them
      // from the MODEL-COLOR-SLOT filename convention.
      if(singleProduct){
        filenameGalleryActive=true;
        const namedEntries=[];
        slides.forEach((slide,n)=>{
          const info=singleProductNamedInfo(slide);
          if(info)namedEntries.push({slide,n,info});
        });

        const contextualEntries=namedEntries.filter(entry=>mediaAllowedByContext(entry.info));
        slides.forEach((slide,n)=>{
          const entry=namedEntries.find(x=>String(x.slide.dataset.mediaId)===String(slide.dataset.mediaId));
          slide.hidden=Boolean(entry && !mediaAllowedByContext(entry.info));
          slide.dataset.mediaRank=String(entry?entry.info.rank:500+n);
          if(entry){
            const label=slide.querySelector('[data-media-label]');
            if(label)label.textContent=entry.info.label;
          }
        });
        thumbs.forEach((thumb,n)=>{
          const entry=namedEntries.find(x=>String(x.slide.dataset.mediaId)===String(thumb.dataset.mediaId));
          thumb.hidden=Boolean(entry && !mediaAllowedByContext(entry.info));
          thumb.dataset.mediaRank=String(entry?entry.info.rank:500+n);
        });
        thumbs
          .slice()
          .sort((a,b)=>Number(a.dataset.mediaRank||10000)-Number(b.dataset.mediaRank||10000))
          .forEach(thumb=>thumbRow?.appendChild(thumb));

        if(contextualEntries.length)renderNamedFit(contextualEntries);
        else restoreLegacyFit();
        show(visibleIndexes()[0]??0);
        updateCount();
        return namedEntries.length>0;
      }

      // Transitional/backwards-compatible mode for old family products.
      const namedEntries=[];
      slides.forEach((slide,n)=>{
        const info=namedInfoForNode(slide,variant);
        if(info)namedEntries.push({slide,n,info});
      });

      if(namedEntries.length){
        filenameGalleryActive=true;
        const contextualEntries=namedEntries.filter(entry=>mediaAllowedByContext(entry.info));
        const allowedIds=new Set(contextualEntries.map(x=>String(x.slide.dataset.mediaId)));
        contextualEntries.forEach(entry=>{
          entry.slide.dataset.mediaRank=String(entry.info.rank);
          const label=entry.slide.querySelector('[data-media-label]');
          if(label)label.textContent=entry.info.label;
        });

        slides.forEach(slide=>slide.hidden=!allowedIds.has(String(slide.dataset.mediaId)));
        thumbs.forEach(thumb=>{
          const entry=contextualEntries.find(x=>String(x.slide.dataset.mediaId)===String(thumb.dataset.mediaId));
          thumb.hidden=!entry;
          if(entry)thumb.dataset.mediaRank=String(entry.info.rank);
        });

        thumbs
          .filter(t=>!t.hidden)
          .sort((a,b)=>Number(a.dataset.mediaRank||10000)-Number(b.dataset.mediaRank||10000))
          .forEach(thumb=>thumbRow?.appendChild(thumb));

        renderNamedFit(contextualEntries);
        const first=visibleIndexes()[0];
        if(first!==undefined)show(first);
        updateCount();
        return true;
      }

      filenameGalleryActive=false;
      restoreLegacyFit();

      const hasAssignedVariantMedia=slides.some(slide=>{
        const ids=(slide.dataset.variantIds||'').split('|').filter(Boolean);
        return ids.length>0;
      });

      if(!hasAssignedVariantMedia){
        slides.forEach(slide=>slide.hidden=false);
        thumbs.forEach(thumb=>thumb.hidden=false);
        show(visibleIndexes()[0]??0);
        updateCount();
        return false;
      }

      slides.forEach(slide=>slide.hidden=!mediaBelongsToVariant(slide,variant.id));
      thumbs.forEach(thumb=>thumb.hidden=!mediaBelongsToVariant(thumb,variant.id));

      const visible=visibleIndexes();
      if(!visible.length){
        slides.forEach(slide=>slide.hidden=false);
        thumbs.forEach(thumb=>thumb.hidden=false);
      }
      show(visibleIndexes()[0]??0);
      updateCount();
      return false;
    };

    root.querySelector('#prevSlide')?.addEventListener('click',()=>stepSlide(-1));
    root.querySelector('#nextSlide')?.addEventListener('click',()=>stepSlide(1));
    thumbs.forEach((t,n)=>t.addEventListener('click',()=>show(n)));

    carousel?.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'){e.preventDefault();stepSlide(-1)}
      if(e.key==='ArrowRight'){e.preventDefault();stepSlide(1)}
    });

    let touchStartX=null;
    carousel?.addEventListener('touchstart',e=>{
      touchStartX=e.changedTouches?.[0]?.clientX ?? null;
    },{passive:true});
    carousel?.addEventListener('touchend',e=>{
      if(touchStartX===null)return;
      const endX=e.changedTouches?.[0]?.clientX ?? touchStartX;
      const delta=endX-touchStartX;
      touchStartX=null;
      if(Math.abs(delta)>45)stepSlide(delta>0?-1:1);
    },{passive:true});

    let qty=1;
    const qtyNode=root.querySelector('#qty');
    const qtyInput=root.querySelector('#qtyInput');
    const setQty=n=>{
      qty=Math.max(1,n);
      if(qtyNode)qtyNode.textContent=qty;
      if(qtyInput)qtyInput.value=qty;
    };
    root.querySelector('#minus')?.addEventListener('click',()=>setQty(qty-1));
    root.querySelector('#plus')?.addEventListener('click',()=>setQty(qty+1));

    let variants=[],props={};
    try{variants=JSON.parse(root.querySelector('[data-product-json]')?.textContent||'[]')}catch(e){}
    try{props=JSON.parse(root.querySelector('[data-variant-properties]')?.textContent||'{}')}catch(e){}

    const money=c=>{
      try{
        return new Intl.NumberFormat(document.documentElement.lang||'pl-PL',{
          style:'currency',
          currency:root.dataset.currency||'PLN'
        }).format((Number(c)||0)/100);
      }catch(e){
        return `${((Number(c)||0)/100).toFixed(2)} ${root.dataset.currency||'PLN'}`;
      }
    };

    const optionGroups=[...root.querySelectorAll('.product-option[data-option-position]')];

    const selected=()=>{
      const out={};
      optionGroups.forEach(group=>{
        const active=group.querySelector('.variant-thumb.active');
        if(active)out[Number(group.dataset.optionPosition)]=active.dataset.optionValue;
      });
      return out;
    };

    const variantMatches=(variant,selection,ignorePosition=null)=>{
      return [1,2,3].every(pos=>{
        if(pos===ignorePosition)return true;
        const selectedValue=selection[pos];
        if(!selectedValue)return true;
        return variant[`option${pos}`]===selectedValue;
      });
    };

    const match=()=>{
      const selection=selected();
      return variants.find(v=>variantMatches(v,selection));
    };

    const truthyFeature=value=>{
      if(value===true || value===1)return true;
      if(value===false || value===0 || value===null || value===undefined)return false;
      const s=String(value).trim().toLowerCase();
      if(!s || ['false','nie','no','0','brak'].includes(s))return false;
      return true;
    };

    const refreshProperties=p=>{
      let visible=0;
      ['uv400','polarization'].forEach(key=>{
        const wrap=root.querySelector(`[data-property-wrap="${key}"]`);
        if(!wrap)return;
        const show=truthyFeature(p?.[key]);
        wrap.hidden=!show;
        if(show)visible++;
      });

      const fitWrap=root.querySelector('[data-property-wrap="fit"]');
      const fitNode=root.querySelector('[data-property="fit"]');
      const fitText=(p?.fit ?? '').toString().trim();
      if(fitWrap){
        fitWrap.hidden=!fitText;
        if(fitNode)fitNode.textContent=fitText;
        if(fitText)visible++;
      }

      const box=root.querySelector('[data-properties-box]');
      if(box)box.hidden=visible===0;
    };

    const refreshOptionStates=()=>{
      const selection=selected();
      optionGroups.forEach(group=>{
        const pos=Number(group.dataset.optionPosition);
        group.querySelectorAll('.variant-thumb').forEach(btn=>{
          const test={...selection,[pos]:btn.dataset.optionValue};
          const exists=variants.some(v=>variantMatches(v,test) && v.available);
          btn.disabled=!exists;
          btn.setAttribute('aria-disabled',exists?'false':'true');
        });
      });
    };

    const update=v=>{
      if(!v)return;

      const meta=props[String(v.id)]||{};
      const id=root.querySelector('[data-variant-id]');
      if(id)id.value=v.id;

      const price=root.querySelector('[data-product-price]');
      if(price)price.textContent=money(v.price);

      const compare=root.querySelector('[data-compare-price]');
      const compareValue=Number(meta.compare_at_price || v.compare_at_price || 0);
      if(compare){
        const showCompare=compareValue>Number(v.price||0);
        compare.hidden=!showCompare;
        compare.textContent=showCompare?money(compareValue):'';
      }

      const current=root.querySelector('#currentColor');
      if(current)current.textContent=v.title==='Default Title'?'':v.title;

      const complianceReady=root.dataset.complianceReady !== '0';
      const stock=root.querySelector('[data-product-stock]');
      const stockText=root.querySelector('[data-stock-text]');
      if(stock)stock.classList.toggle('is-out',!v.available || !complianceReady);
      if(stockText)stockText.textContent=!complianceReady?svT('compliance_hold','Tymczasowo niedostępne'):(v.available?svT('available','Dostępny'):svT('unavailable','Niedostępny'));

      const add=root.querySelector('.add');
      if(add){
        add.disabled=!v.available || !complianceReady;
        add.textContent=!complianceReady?svT('compliance_hold_upper','TYMCZASOWO NIEDOSTĘPNE'):(v.available?svT('add_to_cart','DODAJ DO KOSZYKA'):svT('sold_out_upper','WYPRZEDANE'));
      }

      const sticky=document.querySelector('[data-sticky-buy]');
      const stickyPrice=sticky?.querySelector('[data-sticky-price]');
      const stickyBtn=sticky?.querySelector('[data-sticky-submit]');
      if(stickyPrice)stickyPrice.textContent=money(v.price);
      if(stickyBtn){
        stickyBtn.disabled=!v.available || !complianceReady;
        stickyBtn.textContent=!complianceReady?svT('compliance_hold_short','Niedostępne'):(v.available?svT('add','Dodaj'):svT('sold_out','Wyprzedane'));
      }

      refreshProperties(meta);
      refreshOptionStates();
      const namedGallery=filterGalleryForVariant(v);

      if(!namedGallery && meta.media_id)showMediaId(meta.media_id);

      const u=new URL(location.href);
      u.searchParams.set('variant',v.id);
      history.replaceState({},'',u);
    };

    root.querySelectorAll('.variant-thumb[data-option-value]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        if(btn.disabled)return;
        const pos=btn.dataset.optionPosition;
        root.querySelectorAll(`.product-option[data-option-position="${pos}"] .variant-thumb`).forEach(x=>{
          x.classList.remove('active');
          x.setAttribute('aria-pressed','false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed','true');

        const label=root.querySelector(`[data-current-option="${pos}"]`);
        if(label)label.textContent=btn.dataset.optionValue;

        update(match());
      });
    });

    document.querySelector('[data-sticky-submit]')?.addEventListener('click',()=>{
      root.querySelector('.add')?.click();
    });

    const initialVariant=variants.find(v=>String(v.id)===String(root.querySelector('[data-variant-id]')?.value)) || variants[0];
    refreshOptionStates();
    if(initialVariant)update(initialVariant);
  }


  // Accordions
  document.querySelectorAll('[data-accordion] > button').forEach(button=>button.addEventListener('click',()=>{
    const acc=button.parentElement;
    const open=acc.classList.toggle('open');
    const sign=button.querySelector('span');
    if(sign)sign.textContent=open?'−':'+';
    button.setAttribute('aria-expanded',open?'true':'false');
  }));


  // SPORT 5.1: legacy activity/lens/accessory/finder handlers removed.
  // The current Sport interactions live in sv-sport.js and the global lens drawer.

  document.querySelectorAll('.filters .filter').forEach(btn=>btn.addEventListener('click',()=>{btn.parentElement.querySelectorAll('.filter').forEach(x=>x.classList.remove('active'));btn.classList.add('active')}));
})();



(() => {
  const routeGrid = document.querySelector('#routeProductGrid');
  if (!routeGrid) return;

  const norm = value => (value || '').toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .replace(/ł/g,'l')
    .trim();

  const route = norm(document.querySelector('[data-route-collection]')?.dataset.routeCollection);
  const allCards = [...routeGrid.querySelectorAll('.product-card')];
  const rankingContext = route.includes('damsk') ? 'damskie' : (route.includes('mesk') ? 'meskie' : '');
  allCards.forEach((card,index)=>{ card.dataset.svOriginalOrder = String(index); });
  allCards.sort((a,b)=>{
    if (!rankingContext) return Number(a.dataset.svOriginalOrder)-Number(b.dataset.svOriginalOrder);
    const aModel = a.dataset.svModel || a.dataset.svFamily || a.dataset.svTitle || '';
    const bModel = b.dataset.svModel || b.dataset.svFamily || b.dataset.svTitle || '';
    const tierDiff = SV_MODEL_PRIORITY.tier(rankingContext,aModel) - SV_MODEL_PRIORITY.tier(rankingContext,bModel);
    return tierDiff || Number(a.dataset.svOriginalOrder)-Number(b.dataset.svOriginalOrder);
  });
  allCards.forEach(card=>routeGrid.appendChild(card));
  const title = document.querySelector('[data-route-title]');
  const desc = document.querySelector('[data-route-description]');
  const count = document.querySelector('[data-route-count]');
  const empty = document.querySelector('[data-route-empty]');
  const filterBox = document.querySelector('[data-route-quick-filters]');

  const copy = {
    damskie:['Damskie.','Jeden model, wszystkie jego kolory w jednym miejscu. Wybierz wersję z poziomu karty modelu.'],
    meskie:['Męskie.','Jeden model, wszystkie jego kolory w jednym miejscu. Wybierz wersję z poziomu karty modelu.'],
    dzieciece:['Dziecięce.','Lekkie modele dziecięce poza linią sportową. Sportowe modele dziecięce znajdziesz wyłącznie w dziale Sport.'],
    unisex:['Unisex.','Produkty uniwersalne — każdy kolor i każda oferta mają własną kartę produktu.'],
    akcesoria:['Akcesoria.','Etui, woreczki, ściereczki i dodatki South Vision — każdy produkt osobno.'],
    everyday:['Na co dzień.','Codzienne okulary South Vision — kolory dostępne z poziomu jednej karty modelu.'],
    all:['Wszystkie produkty.','Okulary codzienne, dziecięce i akcesoria. Modele sportowe pozostają wyłącznie w dziale Sport.']
  };
  if (copy[route]) {
    if (title) title.textContent = copy[route][0];
    if (desc) desc.textContent = copy[route][1];
  }

  const routeParams = new URLSearchParams(location.search);
  const fixedStyle = norm(document.querySelector('[data-route-fixed-style]')?.dataset.routeFixedStyle || '');
  let activeStyle = fixedStyle || norm(routeParams.get('svstyle') || '');
  let activeAccessoryFamily = norm(routeParams.get('svacc') || '');
  let currentPage = 1;
  const perPage = 25;

  const colorAliases = {
    czarn:['czarn','black'], braz:['braz','brown'], niebies:['niebies','blue','navy','granat'], roz:['roz','pink','rose'],
    zol:['zol','yellow','amber','burszt'], ziel:['ziel','green'], transparent:['transparent','clear','przezrocz'],
    zlot:['zlot','gold'], srebr:['srebr','silver'], panter:['panter','tortoise','havanna','havana']
  };

  const cardGroups = card => norm(card.dataset.svGroups).split(/\s+/).filter(Boolean);
  const cardStyle = card => norm(card.dataset.svStyle);
  const cardBelongs = card => {
    const groups = cardGroups(card);
    if (!route) return true;
    if (route === 'all') return !groups.includes('sport');
    return groups.includes(route);
  };
  const cardMatchesStyle = card => !activeStyle || cardStyle(card).includes(activeStyle);
  const colorMatches = (haystack,key) => {
    if (!key) return true;
    const words = colorAliases[key] || [key];
    return words.some(word => norm(haystack).includes(word));
  };
  const priceMatches = (card,range) => {
    if (!range) return true;
    const price = Number(card.dataset.svPriceCents || 0) / 100;
    if (range === '0-100') return price < 100;
    if (range === '100-150') return price >= 100 && price <= 150;
    if (range === '150-200') return price > 150 && price <= 200;
    if (range === '200+') return price > 200;
    return true;
  };
  const familyMatches = card => {
    if (!activeAccessoryFamily) return true;
    const hay = norm(`${card.dataset.svAccessoryFamily || ''} ${card.dataset.svTitle || ''}`);
    const key = activeAccessoryFamily.replace(/-/g,' ');
    if (key === 'care') return /worecz|scierecz|mikrofibr|care|pielegn/.test(hay);
    return hay.includes(key);
  };
  const quickMatches = card => {
    if (!filterBox) return true;
    const price = filterBox.querySelector('[data-route-filter="price"]')?.value || '';
    const lens = filterBox.querySelector('[data-route-filter="lens"]')?.value || '';
    const frame = filterBox.querySelector('[data-route-filter="frame"]')?.value || '';
    return priceMatches(card,price) && colorMatches(card.dataset.svLens || '',lens) && colorMatches(card.dataset.svFrame || '',frame);
  };

  document.querySelectorAll('[data-route-style]').forEach(btn => {
    btn.classList.toggle('active', norm(btn.dataset.routeStyle) === activeStyle);
  });

  let pager = routeGrid.parentElement?.querySelector('[data-route-pagination]');
  if (!pager) {
    pager = document.createElement('nav');
    pager.className = 'sv-pagination sv-pagination--client';
    pager.setAttribute('data-route-pagination','');
    pager.setAttribute('aria-label','Strony produktów');
    routeGrid.insertAdjacentElement('afterend',pager);
  }

  const renderPager = pages => {
    if (!pager) return;
    if (pages <= 1) { pager.innerHTML=''; pager.hidden=true; return; }
    pager.hidden=false;
    let html = currentPage > 1 ? `<button type="button" data-page="${currentPage-1}" aria-label="Poprzednia strona">←</button>` : '';
    for (let i=1;i<=pages;i++) {
      if (pages > 7 && i !== 1 && i !== pages && Math.abs(i-currentPage)>2) {
        if ((i===2 && currentPage>4) || (i===pages-1 && currentPage<pages-3)) html += '<span>…</span>';
        continue;
      }
      html += `<button type="button" data-page="${i}"${i===currentPage?' class="is-current" aria-current="page"':''}>${i}</button>`;
    }
    if (currentPage < pages) html += `<button type="button" data-page="${currentPage+1}" aria-label="Następna strona">→</button>`;
    pager.innerHTML = html;
    pager.querySelectorAll('[data-page]').forEach(btn => btn.addEventListener('click',()=>{
      currentPage = Number(btn.dataset.page) || 1;
      render();
      routeGrid.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    }));
  };

  const render = () => {
    const rawMatches = allCards.filter(card => cardBelongs(card) && cardMatchesStyle(card) && familyMatches(card) && quickMatches(card));
    const seenModels = new Set();
    const matches = rawMatches.filter(card => {
      const key = (card.dataset.svModelKey || card.dataset.svFamily || card.dataset.svModel || card.dataset.svTitle || '').trim().toLowerCase();
      if (!key) return true;
      if (seenModels.has(key)) return false;
      seenModels.add(key);
      return true;
    });
    const pages = Math.max(1,Math.ceil(matches.length/perPage));
    if (currentPage > pages) currentPage = pages;
    const start = (currentPage-1)*perPage;
    const pageSet = new Set(matches.slice(start,start+perPage));

    allCards.forEach(card => {
      const filterMatch = matches.includes(card);
      card.dataset.svFilterMatch = filterMatch ? '1' : '0';
      card.dataset.svModelDuplicate = (!filterMatch && rawMatches.includes(card)) ? '1' : '0';
      card.hidden = !filterMatch || !pageSet.has(card);
    });

    if (count) count.textContent = matches.length;
    if (empty) empty.hidden = matches.length !== 0;
    routeGrid.classList.add('product-grid-ready');
    renderPager(matches.length ? pages : 0);
  };

  document.querySelectorAll('[data-route-style]').forEach(btn => btn.addEventListener('click', () => {
    if (fixedStyle) return;
    document.querySelectorAll('[data-route-style]').forEach(x => x.classList.remove('active'));
    btn.classList.add('active');
    activeStyle = norm(btn.dataset.routeStyle);
    currentPage = 1;
    render();
  }));

  filterBox?.querySelectorAll('[data-route-filter]').forEach(select => select.addEventListener('change',()=>{currentPage=1;render()}));
  filterBox?.querySelector('[data-route-filter-clear]')?.addEventListener('click',()=>{
    filterBox.querySelectorAll('select').forEach(select=>select.value='');
    currentPage=1;render();
  });

  render();

})();



/* ==========================================================
   SOUTH VISION 4.2 — live search + interactive lens lab
   ========================================================== */
(() => {
  const overlay = document.querySelector('[data-search-overlay]');
  const openers = [...document.querySelectorAll('[data-search-open]')];
  if (overlay && openers.length) {
    const input = overlay.querySelector('[data-live-input]');
    const open = () => {
      overlay.hidden = false;
      document.body.classList.add('sv-search-open');
      requestAnimationFrame(() => input?.focus());
    };
    const close = () => {
      overlay.hidden = true;
      document.body.classList.remove('sv-search-open');
    };
    openers.forEach(btn => btn.addEventListener('click', open));
    overlay.querySelectorAll('[data-search-close]').forEach(btn => btn.addEventListener('click', close));
    overlay.querySelector('[data-search-clear]')?.addEventListener('click', () => {
      if (!input) return;
      input.value = '';
      input.dispatchEvent(new Event('input', {bubbles:true}));
      input.focus();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });
  }

  const escapeHtml = value => String(value || '').replace(/[&<>"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]));
  const moneyLabel = value => {
    if (value === undefined || value === null || value === '') return '';
    const text = String(value);
    if (/\d/.test(text) && /[A-Za-zł€$£]/.test(text)) return text;
    const number = Number(text);
    if (!Number.isFinite(number)) return text;
    const currency=window.Shopify?.currency?.active || 'PLN';
    return new Intl.NumberFormat(document.documentElement.lang||'pl-PL',{style:'currency',currency}).format(number / (number > 1000 ? 100 : 1));
  };

  document.querySelectorAll('[data-sv-live-search]').forEach(form => {
    const input = form.querySelector('[data-live-input]') || form.querySelector('input[type="search"]');
    const results = form.querySelector('[data-live-results]');
    const status = form.querySelector('[data-live-status]');
    if (!input || !results) return;
    let timer = 0;
    let controller = null;
    let lastQuery = '';

    const renderEmpty = text => {
      results.innerHTML = `<div class="sv-live-search__empty">${escapeHtml(text)}</div>`;
    };
    const renderSuggestions = payload => {
      const bucket = payload?.resources?.results || {};
      const products = bucket.products || [];
      const secondary = [
        ...(bucket.collections || []).map(x=>({...x,_type:'Kolekcja'})),
        ...(bucket.pages || []).map(x=>({...x,_type:'Strona'})),
        ...(bucket.articles || []).map(x=>({...x,_type:'Magazyn'}))
      ].slice(0,6);

      if (!products.length && !secondary.length) {
        renderEmpty(svT('search_empty','Brak wyników. Spróbuj nazwy modelu, koloru albo właściwości.'));
        return;
      }

      const productHtml = products.map(product => {
        const image = product.featured_image?.url || product.image || '';
        const price = moneyLabel(product.price);
        return `<a class="sv-live-result" href="${escapeHtml(product.url)}">
          <span class="sv-live-result__media">${image ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">` : '<span>SV</span>'}</span>
          <span class="sv-live-result__copy"><strong>${escapeHtml(product.title)}</strong>${price ? `<span>${escapeHtml(price)}</span>` : ''}<em>${escapeHtml(svT('view_product','Zobacz produkt'))} →</em></span>
        </a>`;
      }).join('');

      const secondaryHtml = secondary.length ? `<div class="sv-live-search__secondary"><span>${escapeHtml(svT('other_results','Inne wyniki'))}</span>${secondary.map(item=>`<a href="${escapeHtml(item.url)}"><b>${escapeHtml(item.title || item.name || '')}</b><em>${escapeHtml(item._type)} →</em></a>`).join('')}</div>` : '';
      results.innerHTML = productHtml + secondaryHtml;
    };

    const search = async query => {
      const q = query.trim();
      lastQuery = q;
      if (q.length < 2) {
        results.innerHTML = '';
        if (status) status.textContent = svT('type_two','Wpisz co najmniej 2 znaki.');
        return;
      }
      controller?.abort();
      controller = new AbortController();
      if (status) status.textContent = svT('searching','Szukam…');
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url,{headers:{'Accept':'application/json'},signal:controller.signal});
        if (!response.ok) throw new Error('search');
        const payload = await response.json();
        if (lastQuery !== q) return;
        const bucket = payload?.resources?.results || {};
        const products = bucket.products || [];
        const otherCount = (bucket.collections || []).length + (bucket.pages || []).length + (bucket.articles || []).length;
        if (status) status.textContent = (products.length || otherCount) ? `${products.length} ${svT('products','produktów')} · ${otherCount} ${svT('other','innych wyników')}` : svT('no_results','Brak wyników');
        renderSuggestions(payload);
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (status) status.textContent = svT('search_failed','Nie udało się pobrać wyników.');
        renderEmpty(svT('search_unavailable','Wyszukiwanie chwilowo niedostępne. Możesz użyć pełnego wyszukiwania.'));
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => search(input.value), 170);
    });
    form.addEventListener('submit', e => {
      e.preventDefault();
      window.clearTimeout(timer);
      search(input.value);
    });
  });
})();

// Legacy inline lens-lab removed in 5.1; the global bottom drawer is the only lens comparison UI.

/* ==========================================================
   SOUTH VISION SESSION FINAL — swatches, gender context, cart drawer
   ========================================================== */
(() => {
  const inferColor = label => {
    const v=(label||'').toLowerCase();
    if(/panter|tortoise|havanna|havana/.test(v)) return 'linear-gradient(135deg,#2b211b 0 28%,#9a6d45 29% 47%,#d0a477 48% 62%,#3a271d 63% 100%)';
    if(/black|czarn/.test(v)) return '#171717';
    if(/white|bial|biał|cream|krem/.test(v)) return '#f0eee8';
    if(/brown|brąz|braz/.test(v)) return '#8b684f';
    if(/grey|gray|szar|graphite|grafit/.test(v)) return '#777a7b';
    if(/gold|zlot|złot/.test(v)) return '#c4a45f';
    if(/silver|srebr/.test(v)) return '#c8c9c7';
    if(/pink|rose|róż|roz/.test(v)) return '#c9939f';
    if(/blue|navy|niebies|granat/.test(v)) return '#55718d';
    if(/green|ziel/.test(v)) return '#667763';
    if(/yellow|amber|żół|zol|burszt/.test(v)) return '#d3a73a';
    if(/purple|violet|fiolet/.test(v)) return '#74627c';
    if(/red|czerw/.test(v)) return '#8f4747';
    if(/transparent|clear|przezrocz/.test(v)) return '#e7e7e2';
    return '#aaa9a3';
  };

  document.querySelectorAll('[data-swatch-label]').forEach(node=>{
    if(node.style.getPropertyValue('--sv-dot') || node.style.getPropertyValue('--sv-dot-image') || node.style.getPropertyValue('--swatch')) return;
    const c=inferColor(node.dataset.swatchLabel || node.getAttribute('title') || '');
    if(c.startsWith('linear-gradient')) node.style.setProperty('--sv-dot-image',c);
    else node.style.setProperty('--sv-dot',c);
  });

  // Fallback family dots: if custom.family_products is not populated yet,
  // build sibling dots from products already loaded in the current grid.
  const allProductCards=[...document.querySelectorAll('.product-card')];
  const groupingKey=card=>{
    const groups=(card.dataset.svGroups||'').toLowerCase().split(/\s+/);
    if(groups.includes('akcesoria')) return (card.dataset.svFamily||'').trim().toLowerCase();
    return (card.dataset.svModelKey||card.dataset.svFamily||card.dataset.svModel||'').trim().toLowerCase();
  };
  const byFamily=new Map();
  allProductCards.forEach(card=>{
    const family=groupingKey(card);
    if(!family)return;
    if(!byFamily.has(family))byFamily.set(family,[]);
    byFamily.get(family).push(card);
  });
  allProductCards.forEach(card=>{
    const family=groupingKey(card);
    const wrap=card.querySelector('.sv-card-swatches');
    const group=byFamily.get(family)||[];
    if(!wrap || group.length<2)return;
    const known=new Set([...wrap.querySelectorAll('[data-family-swatch]')].map(x=>x.dataset.url||''));
    let existingCount=wrap.querySelectorAll('[data-family-swatch]').length;
    for(const sibling of group){
      if(sibling===card || known.has(sibling.dataset.cardUrl||''))continue;
      const btn=document.createElement('button');
      btn.type='button';btn.className='sv-card-swatch';btn.setAttribute('aria-pressed','false');
      if(existingCount>=5){btn.classList.add('is-extra');btn.hidden=true;btn.dataset.swatchExtra='';}
      btn.dataset.familySwatch='';btn.dataset.url=sibling.dataset.cardUrl||'#';btn.dataset.title=sibling.dataset.svModel||sibling.dataset.svTitle||'';btn.dataset.colorName=sibling.dataset.svColor||'';btn.dataset.price=sibling.dataset.svPrice||'';btn.dataset.image=sibling.dataset.svImage||'';btn.dataset.hoverImage=sibling.dataset.svHoverImage||'';btn.dataset.swatchLabel=sibling.dataset.svColor||sibling.dataset.svTitle||'';btn.title=btn.dataset.swatchLabel;btn.innerHTML='<span></span>';
      const c=inferColor(btn.dataset.swatchLabel);if(c.startsWith('linear-gradient'))btn.style.setProperty('--sv-dot-image',c);else btn.style.setProperty('--sv-dot',c);
      wrap.appendChild(btn);known.add(btn.dataset.url);existingCount++;
    }
    const extras=[...wrap.querySelectorAll('[data-swatch-extra]')];
    let more=wrap.querySelector('[data-swatches-more]');
    if(extras.length>0){
      if(!more){more=document.createElement('button');more.type='button';more.className='sv-card-swatches__more';more.dataset.swatchesMore='';more.setAttribute('aria-expanded','false');wrap.appendChild(more)}
      more.textContent=`+${extras.length}`;
      more.setAttribute('aria-label',svT('showMoreColors','Pokaż więcej kolorów'));
    }
  });

  document.querySelectorAll('[data-swatches-more]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const wrap=btn.closest('.sv-card-swatches');if(!wrap)return;
      const extras=[...wrap.querySelectorAll('[data-swatch-extra]')];
      const open=btn.getAttribute('aria-expanded')==='true';
      extras.forEach(x=>x.hidden=open);
      btn.setAttribute('aria-expanded',open?'false':'true');
      btn.textContent=open?`+${extras.length}`:'−';
      btn.setAttribute('aria-label',open?svT('showMoreColors','Pokaż więcej kolorów'):svT('hideMoreColors','Ukryj dodatkowe kolory'));
    });
  });

  document.querySelectorAll('[data-sv-card]').forEach(()=>{}); // compatibility marker
  document.querySelectorAll('.product-card').forEach(card=>{
    const swatches=[...card.querySelectorAll('[data-family-swatch]')];
    if(!swatches.length)return;
    const links=[...card.querySelectorAll('[data-sv-card-link]')];
    const title=card.querySelector('[data-sv-card-title]');
    const color=card.querySelector('[data-sv-card-color-name]');
    const price=card.querySelector('[data-sv-card-price]');
    const image=card.querySelector('[data-sv-card-primary-image]') || card.querySelector('.product-media a .real-img.contain');
    const hoverImage=card.querySelector('.product-media .model-real');

    swatches.forEach(btn=>btn.addEventListener('click',()=>{
      swatches.forEach(x=>{x.classList.toggle('is-active',x===btn);x.setAttribute('aria-pressed',x===btn?'true':'false')});
      const url=btn.dataset.url || card.dataset.cardUrl || '#';
      card.dataset.cardUrl=url;
      links.forEach(a=>a.href=url);
      if(title && btn.dataset.title)title.textContent=btn.dataset.title;
      if(color)color.textContent=btn.dataset.colorName || '';
      if(price && btn.dataset.price)price.textContent=btn.dataset.price;
      if(image && btn.dataset.image){
        image.style.opacity='.25';
        const pre=new Image();
        pre.onload=()=>{image.src=btn.dataset.image;image.srcset='';image.alt=btn.dataset.title||'';image.style.opacity='1'};
        pre.src=btn.dataset.image;
      }
      if(hoverImage){
        if(btn.dataset.hoverImage){hoverImage.src=btn.dataset.hoverImage;hoverImage.srcset='';hoverImage.hidden=false;}
        else{hoverImage.hidden=true;}
      }
    }));
  });

  // Preserve D/M context while changing a product colour/family on PDP.
  const gender=(new URLSearchParams(location.search).get('sv_gender')||'').toLowerCase();
  if(gender==='d'||gender==='m'){
    document.querySelectorAll('[data-preserve-gender-link]').forEach(a=>{
      try{
        const u=new URL(a.href,location.origin);u.searchParams.set('sv_gender',gender);a.href=u.pathname+u.search+u.hash;
      }catch(_){ }
    });
  }
})();

(() => {
  const drawer=document.querySelector('[data-cart-drawer]');
  if(!drawer)return;
  const openers=[...document.querySelectorAll('[data-cart-drawer-open]')];
  const closers=[...drawer.querySelectorAll('[data-cart-drawer-close]')];
  const loading=drawer.querySelector('[data-cart-drawer-loading]');
  const empty=drawer.querySelector('[data-cart-drawer-empty]');
  const items=drawer.querySelector('[data-cart-drawer-items]');
  const footer=drawer.querySelector('[data-cart-drawer-footer]');
  const total=drawer.querySelector('[data-cart-drawer-total]');
  const shipping=drawer.querySelector('[data-cart-shipping]');
  const shippingCopy=drawer.querySelector('[data-cart-shipping-copy]');
  const shippingProgress=drawer.querySelector('[data-cart-shipping-progress]');
  const countNodes=[...document.querySelectorAll('[data-cart-count]')];
  const currency=window.Shopify?.currency?.active || document.querySelector('[data-product-root]')?.dataset.currency || 'PLN';
  const root=window.Shopify?.routes?.root || '/';

  const money=c=>{try{return new Intl.NumberFormat('pl-PL',{style:'currency',currency}).format((Number(c)||0)/100)}catch(_){return `${((Number(c)||0)/100).toFixed(2)} ${currency}`}};
  const esc=v=>String(v??'').replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const setCount=n=>countNodes.forEach(node=>{node.textContent=n;node.hidden=!n});

  const render=cart=>{
    loading.hidden=true;setCount(cart.item_count);
    if(!cart.item_count){empty.hidden=false;items.hidden=true;footer.hidden=true;items.innerHTML='';return}
    empty.hidden=true;items.hidden=false;footer.hidden=false;total.textContent=money(cart.total_price);
    items.innerHTML=cart.items.map(item=>`<div class="sv-cart-line" data-cart-key="${esc(item.key)}">
      <a class="sv-cart-line__media" href="${esc(item.url)}">${item.image?`<img src="${esc(item.image)}&width=220" alt="${esc(item.product_title)}" loading="lazy">`:''}</a>
      <div class="sv-cart-line__copy"><a href="${esc(item.url)}"><strong>${esc(item.product_title)}</strong></a>${item.variant_title&&item.variant_title!=='Default Title'?`<span>${esc(item.variant_title)}</span>`:''}<div class="sv-cart-line__qty"><button type="button" data-cart-minus aria-label="${esc(svT('decrease_quantity','Zmniejsz ilość'))}">−</button><span>${item.quantity}</span><button type="button" data-cart-plus aria-label="${esc(svT('increase_quantity','Zwiększ ilość'))}">+</button></div><button type="button" class="sv-cart-line__remove" data-cart-remove>${esc(svT('remove','Usuń'))}</button></div>
      <b>${money(item.final_line_price)}</b>
    </div>`).join('');
    if(shipping){const threshold=Number(shipping.dataset.threshold||0);if(threshold>0){const pct=Math.min(100,cart.total_price/threshold*100);shippingProgress.style.width=`${pct}%`;shippingCopy.textContent=cart.total_price>=threshold?svT('free_shipping','Masz darmową dostawę ✓'):svT('free_shipping_remaining','Brakuje {amount} do darmowej dostawy').replace('{amount}',money(threshold-cart.total_price));}}
  };
  const load=()=>{loading.hidden=false;empty.hidden=true;items.hidden=true;footer.hidden=true;return fetch(`${root}cart.js`,{headers:{Accept:'application/json'}}).then(r=>r.json()).then(render).catch(()=>{loading.textContent=svT('cart_load_failed','Nie udało się załadować koszyka.')})};
  const open=()=>{drawer.hidden=false;document.body.classList.add('sv-cart-open');openers.forEach(x=>x.setAttribute('aria-expanded','true'));load()};
  const close=()=>{drawer.hidden=true;document.body.classList.remove('sv-cart-open');openers.forEach(x=>x.setAttribute('aria-expanded','false'))};
  const change=(key,quantity)=>fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})}).then(r=>r.json()).then(render);

  openers.forEach(x=>x.addEventListener('click',open));closers.forEach(x=>x.addEventListener('click',close));
  items.addEventListener('click',e=>{const line=e.target.closest('[data-cart-key]');if(!line)return;const key=line.dataset.cartKey;const qty=Number(line.querySelector('.sv-cart-line__qty span')?.textContent||1);if(e.target.closest('[data-cart-minus]'))change(key,Math.max(0,qty-1));if(e.target.closest('[data-cart-plus]'))change(key,qty+1);if(e.target.closest('[data-cart-remove]'))change(key,0)});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!drawer.hidden)close()});

  // Product page: Ajax add-to-cart, then open the drawer instead of navigating away.
  document.querySelectorAll('form[action*="/cart/add"], .product-form').forEach(form=>{
    if(form.dataset.svAjaxCart==='1')return;form.dataset.svAjaxCart='1';
    form.addEventListener('submit',async e=>{
      if(!form.querySelector('[name="id"]'))return;
      e.preventDefault();
      const submit=form.querySelector('[type="submit"]');const old=submit?.textContent;
      if(submit){submit.disabled=true;submit.textContent='DODAJĘ…'}
      try{
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        if(!response.ok)throw new Error('add');
        await load();open();
      }catch(_){if(submit)submit.textContent='SPRÓBUJ PONOWNIE'}
      finally{if(submit){submit.disabled=false;if(submit.textContent!=='SPRÓBUJ PONOWNIE')submit.textContent=old}}
    });
  });
})();

(() => {
  const panel=document.querySelector('[data-shopify-filter-panel]');
  if(!panel)return;
  const close=()=>{panel.hidden=true;document.body.style.overflow=''};
  panel.querySelectorAll('[data-filter-panel-close]').forEach(btn=>btn.addEventListener('click',close));
  document.querySelectorAll('[data-filter-toggle]').forEach(btn=>btn.addEventListener('click',()=>{if(!panel.hidden)document.body.style.overflow='hidden'}));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden)close()});
})();
